import PropTypes from 'prop-types'
import { useState, useEffect, useRef } from 'react'
import Router from 'next/router'
import Box from '@material-ui/core/Box'
import InputBase from '@material-ui/core/InputBase'
import IconButton from '@material-ui/core/IconButton'
import Fade from '@material-ui/core/Fade'
import SearchIcon from '@material-ui/icons/Search'
import useMediaQuery from '@material-ui/core/useMediaQuery'
import { useTheme } from '@material-ui/core/styles'
import { StatesQuery } from '@components/states'
import Tab from '@components/tab'
import useClickOutside from '@hooks/useClickOutside'
import useStyles from './search-course.styles'


const texts = {
  placeholder: ['search by course name, city and state', 'search by zipcode'],
  itemsTabs: [{ headline: 'explore courses' }, { headline: 'courses near me' }],
  typeOfSearch: ['searchText', 'zipCode'],
}

const SearchCourse = ({
  dark, withDropdown = false, withTabs = false, ssrStatesData,
}) => {
  const theme = useTheme()
  const small = useMediaQuery(theme.breakpoints.down('sm'))
  const styles = useStyles()
  const [searchText, changeSearch] = useState('')
  const [open, setOpen] = useState(false)
  const wrapperRef = useRef(null)
  const clickedOutside = useClickOutside(wrapperRef)
  const [valueTab, setValueTab] = useState(0)

  useEffect(() => setOpen(false),
    [clickedOutside])


  const executeSearch = () => {
    if (searchText.length >= 3) {
      Router.push(`/play/search?${texts.typeOfSearch[valueTab]}=${searchText}`)
    }
  }

  const handleKeyDown = (event) => {
    if (event.key === 'Enter') { executeSearch() }
  }

  const handleChangeTab = (newValue) => {
    setValueTab(newValue)
    changeSearch('')
  }

  return (
    <div ref={wrapperRef}>
      <div className={`${styles.root} ${dark ? 'theme-dark' : ''}`} data-testid="play-search" data-theme={dark ? 'dark' : 'light'}>
        <InputBase
          placeholder={small ? 'Search' : texts.placeholder[valueTab]}
          className={styles.input}
          value={searchText}
          onChange={event => changeSearch(event.target.value)}
          onFocus={() => setOpen(true)}
          type={valueTab === 0 ? 'text' : 'number'}
          onKeyDown={handleKeyDown}
          data-testid="input-search"
        />
        <IconButton
          className={styles.iconButton}
          aria-label="search"
          onClick={executeSearch}
          data-testid="search-button"
        >
          <SearchIcon />
        </IconButton>
      </div>
      {withTabs && (
        <div className={styles.tabs} data-testid="search-tabs">
          <Tab color={dark ? 'black' : 'white'} align="left" items={texts.itemsTabs} handleChange={handleChangeTab} />
        </div>
      )}
      {withDropdown && !small && (
        <Fade in={open}>
          <Box
            className={styles.dropdown}
            position="absolute"
            mt={1}
            width={['94%', '96.5%', '95.5%']}
            data-testid="states-dropdown"
          >
            <StatesQuery insideSearchBar ssrData={ssrStatesData} />
          </Box>
        </Fade>
      )}
    </div>
  )
}

SearchCourse.propTypes = {
  dark: PropTypes.bool,
  withDropdown: PropTypes.bool,
  withTabs: PropTypes.bool,
  ssrStatesData: PropTypes.array,
}


export default SearchCourse
